import { ENTITY_TYPES } from '@sales-center/common'
import { ActivityHistoryFilters, ActivityHistorySearchInput } from '../state'

export function filtersToSearchInput(
  entityId: number,
  entityType: ENTITY_TYPES,
  filters: ActivityHistoryFilters,
) {
  const filter: ActivityHistorySearchInput = {
    activityTypeIds: filters.customActivities.filters
      .filter((x) => x.isSelected)
      .map((x) => x.id),
    entityId: entityId,
    entityType: entityType,
    showAgreement: !!filters.closingActivities.filters.find(
      (x) => x.name === 'Agreement' && x.isSelected,
    ),
    showCardCapture: !!filters.closingActivities.filters.find(
      (x) => x.name === 'Card Capture' && x.isSelected,
    ),
    showFunnelUpdate: !!filters.statusUpdates.filters.find(
      (x) => x.name === 'Funnel Update' && x.isSelected,
    ),
    showScheduling: !!filters.closingActivities.filters.find(
      (x) => x.name === 'Scheduling' && x.isSelected,
    ),
    showService: !!filters.closingActivities.filters.find(
      (x) => x.name === 'Service' && x.isSelected,
    ),
    showAssignmentUpdate: !!filters.statusUpdates.filters.find(
      (x) => x.name === 'Assignment Update' && x.isSelected,
    ),
    showKnockStatusUpdate: !!filters.statusUpdates.filters.find(
      (x) => x.name === 'Knock Status Update' && x.isSelected,
    ),
  }

  return filter
}
